import { render } from "./Lore.vue?vue&type=template&id=e78aa8ce&bindings={\"audioFiles\":\"data\"}"
import script from "./Lore.vue?vue&type=script&lang=js"
export * from "./Lore.vue?vue&type=script&lang=js"

import "./Lore.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script